module.exports = __webpack_public_path__ + "static/media/logo_anisse.0560b095.png";